import { render, staticRenderFns } from "./scope54.vue?vue&type=template&id=49b8b772&scoped=true"
import script from "./scope54.vue?vue&type=script&lang=js"
export * from "./scope54.vue?vue&type=script&lang=js"
import style0 from "./scope54.vue?vue&type=style&index=0&id=49b8b772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8b772",
  null
  
)

export default component.exports